import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysOutSourcingButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.outSourcing")}</ActionButtonLayout>;

}

export default MomSysOutSourcingButtonLayout;

